/*
 * Module for one lonesome report
 */

//DataModel imported because we reqres it
define([
  "marionette",
  "backbone",
  "highcharts/highcharts",
  "jquery",
  "moment",
  "messaging/messenger",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "modules/reportSplit/reports/reportModel",
], function (Marionette, Backbone, Highcharts, $, Moment, Messenger, ReportUtilities) {
  const StackedColumnReportShow = function (report, renderTo, singleReportModule) {
    const clickAction = _clickActionAction(report);

    if (report.type === "stackedColumn" || report.type === "bar") {
      let notSpecified = "";
      if (report.options.title === undefined) {
        notSpecified = "\nreport.options.title";
      }
      if (report.options.xAxisTitle === undefined) {
        notSpecified = notSpecified + "\nxAxisTitle";
      }
      if (report.options.yAxisTitle === undefined) {
        notSpecified = notSpecified + "\nyAxisTitle";
      }
      if (notSpecified !== "") {
        Messenger.okDialog(
          "The following report options are required for line charts, but were not specified:\n" +
            notSpecified +
            "\n\nThey must be added to the report when it is created on the server.  The report will not be able to display until they are added.",
        );
        return;
      }
      /**
       * This report is more like what one of our real reports will look like, despite it being a made-up report.
       * The reqres call below retieves the data that will be displayed in HighCharts (assigned in the series below).
       *
       * The handler for the reqres calls for dataSets should be placed in dataModel.js to keep them all together; you
       * can find this one by searching for "lineChartData" in dataModel.js.  The same reqres call can be used by other
       * charts that are line charts.
       */
      let dataSet = Messenger.reqres.request("multiLineData", report.href);
      console.log(dataSet);
      /**
       * Ths .once("sync" code here is very important.  This waits for the data to be retrieved from the web server
       * before doing what is inside of it (which is displaying the HighChart).  If this weren't here, we'd wind up
       * with charts that showed nothing because they would be drawn before the data for them arrived.
       */
      singleReportModule.listenTo(
        dataSet,
        "sync",
        function () {
          //dataSet.once("sync", function() {
          //show the single report layout
          singleReportModule.showRegion(singleReportModule.layout);
          Messenger.vent.trigger("report:arrived", report);
          console.log(dataSet);
          /**
           * Retrieve the parameters that the user gave for the configuration.
           */
          let currentTitle;
          if (dataSet.get("customTitle")) {
            currentTitle = $.t(dataSet.get("customTitle"));
          } else {
            currentTitle = $.t(report.options.title);
            currentTitle = ReportUtilities.figureOutText(currentTitle, true);
          }
          let xAxisTitle = "X Axis";
          if (dataSet.get("customXAxis")) {
            xAxisTitle = $.t(dataSet.get("customXAxis"));
          } else {
            xAxisTitle = $.t(report.options.xAxisTitle);
          }
          const yAxisTitle = $.t(report.options.yAxisTitle);

          let subTitleText = null;
          if (report.options.subTitle) {
            subTitleText = $.t(report.options.subTitle);
          }
          if (subTitleText !== null) {
            subTitleText = ReportUtilities.figureOutText(subTitleText, true);
          }
          /**
           * The data comes back as (usually) a Backbone collection.  This works well for retrieving it from the RESTful
           * service on this web server, and generally we'll want to keep it in this format.  However, HighCharts needs
           * it in JSON format to display the chart.  We can get this by simply calling the .toJSON() method on it.
           * JSON.stringify(dataSet) should also work.
           */
          dataSet = dataSet.toJSON();
          dataSet.categories = dataSet.categories.toJSON();
          //post-processing
          for (let i = 0; i < dataSet.categories.length; i++) {
            dataSet.categories[i].value = $.t(dataSet.categories[i].value);
            const suffix = dataSet.categories[i].suffix;
            if (suffix) {
              dataSet.categories[i] = dataSet.categories[i].value + " " + suffix;
            } else {
              dataSet.categories[i] = dataSet.categories[i].value;
            }
          }

          if (report.href.startsWith("/trendingII")) {
            const topicChoicesArray = [];
            for (let i = 0; i < dataSet.categories.length; i++) {
              const id = dataSet.categories[i].substring(dataSet.categories[i].indexOf("|") + 1);
              dataSet.categories[i] = dataSet.categories[i].substring(
                0,
                dataSet.categories[i].indexOf("|"),
              );
              topicChoicesArray[i + 1] = id;
            }
            Messenger.reqres.setHandler(
              "reports:intentID",
              function (intentName) {
                return topicChoicesArray[intentName];
              },
              this,
            );
          }

          dataSet.lines = dataSet.lines.toJSON();
          for (let i = 0; i < dataSet.lines.length; i++) {
            if (dataSet.lines[i].name !== null) {
              dataSet.lines[i].name = $.t(dataSet.lines[i].name);
            } else {
              Messenger.okDialog("this series should have a name");
            } //REMOVE BEFORE RELEASE
          }
          if (report.href.startsWith("/catWeekGraph")) {
            const touchpoints = Messenger.reqres.request("kb:touchpoints");
            for (let i = 0; i < touchpoints.length; i++) {
              const point = touchpoints.models[i];
              if (point.get("touchPointId") === Number(dataSet.lines[0].name)) {
                dataSet.lines[0].name = point.get("touchPoint");
                break;
              }
            }
            //dataSet.lines[0].name = Messenger.reqres.request("reports:intentName", dataSet.lines[0].name);
          }

          const addWeekCategories = function (dataSet) {
            const categories = [];
            dataSet.lines.forEach((line) => {
              for (let i = categories.length; i < line.data.length; ++i) {
                const startWeek = line.data[i].startWeek;
                const endWeek = line.data[i].endWeek;
                const label =
                  Messenger.reqres.request("get:formatted:date:short", startWeek) +
                  " - " +
                  Messenger.reqres.request("get:formatted:date:short", endWeek);
                categories.push(label);
              }
            });
            return categories;
          };

          // If the report is the weekly topic detail or the category traffic dashboard,
          // then the categories (weekly date ranges) will need set by locale
          if (
            report.href.startsWith("/topicDetail/Weekly") ||
            report.href.startsWith("/categoryTrafficDashboard") ||
            report.href.startsWith("/dashboardUsageLong")
          ) {
            dataSet.categories = addWeekCategories(dataSet);
          } else if (report.href.startsWith("/topicDetail/{interval}")) {
            const interval = Messenger.reqres.request("param:{interval}", "{interval}");
            if (interval === "Weekly") {
              dataSet.categories = addWeekCategories(dataSet);
            }
          }

          //Set the proper x axis type
          //Not doing this can result in some column labels being left out (if it's always linear), in
          //the case that the distance between the closest two data points is more than one
          //See: http://api.highcharts.com/highcharts#plotOptions.column.pointRange
          //Actually, this doesn't seem to matter; even if it's 'category', that persists.
          //However, setting the point range explicitly fixes the problem
          //We may also be able to use that manually to label, say, every 3 months
          let xAxisType = "linear";
          if (dataSet.categories) {
            xAxisType = "category";
          }

          const checkForData = function (dataSet) {
            for (let i = 0; i < dataSet.lines.length; i++) {
              for (let k = 0; k < dataSet.lines[i].data.length; k++) {
                if (dataSet.lines[i].data[k].y !== 0 && dataSet.lines[i].data[k].y !== null) {
                  return true;
                }
              }
            }
            return false;
          };

          const hasData = checkForData(dataSet);
          //hasData ? alert(currentTitle + " has Data"):alert(currentTitle + " has No Data");
          if (!hasData) {
            subTitleText = $.t("reports.noData.long");
          }

          const type =
            report.type === "stackedColumn"
              ? "column"
              : report.type === "bar"
                ? "bar"
                : Messenger.okDialog("invalid chart type");
          $(function () {
            singleReportModule.createChart({
              chart: {
                type: type,
              },
              title: {
                text: currentTitle,
              },
              subtitle: {
                text: subTitleText,
              },
              xAxis: {
                type: xAxisType,
                title: {
                  text: xAxisTitle,
                },
                labels: {
                  autoRotation: [-30, -45],
                  formatter: function () {
                    return this.value; //this prevents HighCharts from adding a comma for readability.  since this is a
                    // year, we don't want that comma
                  },
                },
                categories: dataSet.categories,

                //optionally could also have gridLineWidth: 1
              },
              yAxis: {
                title: {
                  text: yAxisTitle,
                },
                startOnTick: false,
                allowDecimals: false,
                stackLabels: {
                  enabled: true,
                },
              },
              plotOptions: {
                column: {
                  stacking: "normal",
                  pointRange: 1,
                  point: {
                    events: {
                      click: function () {
                        if (clickAction === null) {
                          //no drilldown; return rather than throwing a NullPointerException
                          return;
                        }
                        const whatever = this.category;
                        clickAction(whatever, this.category);
                      },
                    },
                  },
                },
                bar: {
                  stacking: "normal",
                  point: {
                    events: {
                      click: function () {
                        if (clickAction === null) {
                          //no drilldown; return rather than throwing a NullPointerException
                          return;
                        }
                        clickAction(this.x + 1, this.category);
                      },
                    },
                  },
                },
              },
              /**
               * At this point the dataSet is already in a format the covers all of the serieses
               */
              series: dataSet.lines,
            });
          });
        },
        this,
      );
    }
  };

  function _clickActionAction(report) {
    let clickAction = null;

    //report-specific stuff
    if (report.href.startsWith("/accuracyDistribution/")) {
      clickAction = function (category) {
        /**
         * Parameter setup.  The Escalation Topic report needs to know which channel you want topics for - it's a
         * parameter. So, we need to set a handler for the topic here. Note that this handler isn't cleared explicitly.
         *  Rather, when the report area view is closed (which it is when a new report is shown), this is cleaned up.
         * Although I'm not 100% sure that this will work with multiple drilldown - I'll find that out fairly soon.
         */
        Messenger.vent.trigger("set:parameter", "bucket", category);
        /**
         * Another attribute of the dataSet for the pieChart reqres is the drillDownReport (which we get from the
         * reportModel).  Here, we retrieve that.
         */
        const ddReport = report.drillDownReport;
        /**
         * If a drilldown exists (which is should), we send out an event to show a new report.  "show:report" will
         * re-route back to the top of this showReport method, with the new report to show as the first parameter.  We
         * also send the leaveExistingConfig view parameter as true (since later on, we won't want drilling down to
         * wipe out config settings).  The last parameter being true is really confusing right now and I need to
         * refactor that.  For now, setting it as true makes the drilldown show up.
         */
        if (ddReport) {
          for (let c = 0; c < ddReport.length; c++) {
            const currentDrillDown = ddReport[c];
            Messenger.vent.trigger("show:drilldown", currentDrillDown);
          }
        }
      };
    } else if (report.href.startsWith("/surveyReport/")) {
      clickAction = function (category, displayName) {
        Messenger.vent.trigger("set:parameter", 5, "{surveyChoice}", category, displayName);

        const ddReport = report.drillDownReport;
        /**
         * If a drilldown exists (which is should), we send out an event to show a new report.  "show:report" will
         * re-route back to the top of this showReport method, with the new report to show as the first parameter.  We
         * also send the leaveExistingConfig view parameter as true (since later on, we won't want drilling down to
         * wipe out config settings).  The last parameter being true is really confusing right now and I need to
         * refactor that.  For now, setting it as true makes the drilldown show up.
         */
        if (ddReport) {
          for (let c = 0; c < ddReport.length; c++) {
            const currentDrillDown = ddReport[c];
            Messenger.vent.trigger("show:drilldown", currentDrillDown);
          }
        }
      };
    }
    return clickAction;
  }

  return StackedColumnReportShow;
});
